import React, { createContext, useContext, useMemo } from 'react';
import { useStore } from '../../context/StoreContext';
import { usePermissions } from '../../context/PermissionContext';
import { normalizeStoreType } from '../../config/tenantTypes';

const TenantContext = createContext(null);

export const TenantProvider = ({ children }) => {
  const { selectedStore, modulesEnabled, isModuleEnabled, businessType } = useStore();
  const { permissions = [], hasPermission, storeRole, loading: permissionsLoading } = usePermissions();

  const value = useMemo(() => {
    const storeId = selectedStore?.id ?? null;
    const storeType = normalizeStoreType(businessType, selectedStore?.store_type);

    return {
      storeId,
      storeType,
      permissions,
      permissionsLoading,
      storeRole,
      selectedStore,
      modulesEnabled: modulesEnabled || {},
      hasPermission,
      isModuleEnabled,
    };
  }, [selectedStore, modulesEnabled, isModuleEnabled, businessType, permissions, permissionsLoading, hasPermission, storeRole]);

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};
